"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'fdmPermission',
      searchQuery: {
        fdmEmpNo: '',
        fdmEmpName: '',
        rsmEmpNo: '',
        rsmEmpName: ''
      },
      apiModule: 'kpiSet'
    };
  },
  computed: {
    domData: function domData() {
      return {
        fdmEmpNo: {
          label: this.$t('sfe.fdmPermission.fdmEmpNo'),
          valueKey: 'fdmEmpNo'
        },
        fdmEmpName: {
          label: this.$t('sfe.fdmPermission.fdmEmpName'),
          valueKey: 'fdmEmpName'
        },
        rsmEmpNo: {
          label: this.$t('sfe.fdmPermission.rsmEmpNo'),
          valueKey: 'rsmEmpNo'
        },
        rsmEmpName: {
          label: this.$t('sfe.fdmPermission.rsmEmpName'),
          valueKey: 'rsmEmpName'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.fdmpermission'),
          apiUrl: '/protected/fdmRsmRef/export'
        },
        import: {
          apiUrl: '/protected/fdmRsmRef/import'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        fdmEmpNo: {
          label: this.$t('sfe.fdmPermission.fdmEmpNo')
        },
        fdmEmpName: {
          label: this.$t('sfe.fdmPermission.fdmEmpName')
        },
        rsmEmpNo: {
          label: this.$t('sfe.fdmPermission.rsmEmpNo')
        },
        rsmEmpName: {
          label: this.$t('sfe.fdmPermission.rsmEmpName')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/fdmRsmRef/list'
      };
    }
  }
};